import {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {useNavigation} from '@react-navigation/native';

import {useTranslation} from '/provider/TranslationProvider';
import {updateMyTeamsFilter} from '/redux/action/myTeams.action';
import {getDefaultNewCoachesKey} from '/util/filter.util';

import {getDefaultFilters} from '../report/MyTeamsReport/util/myTeamsFilterDomain.util';

import {UseTeamsProps, UseTeamsPropsReturn} from './Teams.types';

export const useTeams = ({
  hasTeamsMetricsById,
  getTeamsMetrics = () => {},
  hasSameDayLastMonth,
  getSameDayLastMonth = () => {},
}: UseTeamsProps): UseTeamsPropsReturn => {
  const {tt} = useTranslation('screen.teams');
  const dispatch = useDispatch();
  const navigation = useNavigation();
  const defaultNewCoachesKey = getDefaultNewCoachesKey(true);
  // Reset Redux filters to defaults
  useEffect(() => {
    const unsubscribe = navigation.addListener('focus', () => {
      dispatch(updateMyTeamsFilter(getDefaultFilters(defaultNewCoachesKey)));
    });
    return unsubscribe;
  }, [navigation, dispatch]);

  useEffect(() => {
    // TODO move this API call somewhere else eventually -- prefetch data on login?
    if (!hasTeamsMetricsById) {
      getTeamsMetrics();
    }
    if (!hasSameDayLastMonth) {
      getSameDayLastMonth();
    }
  });

  return {tt};
};
